import parseISO from "date-fns/parseISO";
import addDays from "date-fns/addDays";
import {isExpired} from "@MyTicket/features/ticketDetails/functions/isExpired";

export const has24HoursPassed = (dateInString: string) => (isExpired(addDays(parseISO(dateInString), 1)))